import { Commit } from 'vuex'

import ErrorEntities from '@/models/error-entities'

import axios from '@/axios-module'
import router from '@/router'
import { CustomerMutationTypes } from '@/store/modules/customer'

export enum NewPasswordPageActionTypes {
  GetWelcomePageMessage = '[NewPasswordPage] GetWelcomePageMessage',
  GetPasswordResetMessage = '[NewPasswordPage] GetPasswordResetMessage',
}

export enum NewPasswordPageMutationTypes {
  GetWelcomePageMessageSuccess = '[NewPasswordPage] GetWelcomePageMessageSuccess',
  GetPasswordResetMessageSuccess = '[NewPasswordPage] GetPasswordResetMessageSuccess',
}

export interface State {
  welcomeMessage: string
  passwordResetMessage: string
  bookingId: number | null
  errors: ErrorEntities
}

const initialState: State = {
  welcomeMessage: '',
  passwordResetMessage: '',
  bookingId: null,
  errors: {},
}

export default {
  state: initialState,
  getters: {
    getNewPasswordPageErrors(state: State) {
      return state.errors
    },
  },
  actions: {
    async [NewPasswordPageActionTypes.GetWelcomePageMessage]({
      commit,
    }: {
      commit: Commit
    }) {
      const response = await axios.get('/customer/welcome_page_message')
      commit(
        NewPasswordPageMutationTypes.GetWelcomePageMessageSuccess,
        response.data,
      )
    },
    async [NewPasswordPageActionTypes.GetPasswordResetMessage]({
      commit,
    }: {
      commit: Commit
    }) {
      const response = await axios.get('/customer/password_reset_message')
      commit(
        NewPasswordPageMutationTypes.GetPasswordResetMessageSuccess,
        response.data,
      )
    },
  },
  mutations: {
    [NewPasswordPageMutationTypes.GetWelcomePageMessageSuccess](
      state: State,
      {
        welcomeMessage,
        bookingId,
      }: { welcomeMessage: string; bookingId: number },
    ) {
      state.welcomeMessage = welcomeMessage
      state.bookingId = bookingId
    },
    [NewPasswordPageMutationTypes.GetPasswordResetMessageSuccess](
      state: State,
      {
        passwordResetMessage,
        bookingId,
      }: { passwordResetMessage: string; bookingId: number },
    ) {
      state.passwordResetMessage = passwordResetMessage
      state.bookingId = bookingId
    },
    [CustomerMutationTypes.ChangeDefaultPasswordSuccess](state: State) {
      state.errors = {}

      const redirectPath = state.bookingId
        ? { name: 'booking', params: { id: `${state.bookingId}` } }
        : { name: 'dashboard' }

      router.push(redirectPath)
    },
    [CustomerMutationTypes.ChangeDefaultPasswordFailure](
      state: State,
      errors: ErrorEntities,
    ) {
      state.errors = errors
    },
  },
}
